import React from 'react';
import { OfferCounterInfo } from '@/types/offer';
import { PoolDetail } from '@/types/pool';
import { getAcceptedCounterOfferInfo } from '@/utils/poolStatus';
import { Tabs } from '../../ui/Tabs';
import { CounterOfferStepper } from './CounterOfferStepper';

type TabId = 'overview' | 'documents';

type PoolDetailTabsProps = {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  pool: PoolDetail;
  counterOfferInfo: OfferCounterInfo | null;
  totalCounterOffers?: number;
  activeCounterOfferIndex?: number;
  onPreviousCounterOffer?: () => void;
  onNextCounterOffer?: () => void;
};

export const PoolDetailTabs: React.FC<PoolDetailTabsProps> = ({
  activeTab,
  onTabChange,
  pool,
  counterOfferInfo,
  totalCounterOffers = 0,
  activeCounterOfferIndex = 0,
  onPreviousCounterOffer,
  onNextCounterOffer,
}) => {
  // Check if there are counter offer documents
  // If counterOfferIndex is provided, use the specific counteroffer at that index
  const acceptCounterOffer = getAcceptedCounterOfferInfo(pool.offers);
  const requestedDocuments = counterOfferInfo?.required_documents || acceptCounterOffer?.required_documents;
  const hasCounterDocuments = (requestedDocuments?.length || 0) > 0;

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'documents', label: 'Assigned Documents', badge: hasCounterDocuments },
  ];

  const showStepper = totalCounterOffers > 1 && onPreviousCounterOffer && onNextCounterOffer;

  return (
    <div className="flex items-center justify-between w-full">
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={(tabId) => onTabChange(tabId as TabId)} />
      {showStepper && (
        <CounterOfferStepper
          totalSteps={totalCounterOffers}
          activeIndex={activeCounterOfferIndex}
          onPrevious={onPreviousCounterOffer}
          onNext={onNextCounterOffer}
        />
      )}
    </div>
  );
};
